import { api } from "@/lib/api";

export function attachmentSrc(m) {
  if (m.attachment_id) return `/attachments/${m.attachment_id}/file`;
  if (m.media_url) return m.media_url.replace(/^\/api/, "");
  return null;
}

export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "arquivo";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export async function downloadAttachment(src, filename) {
  const { data } = await api.get(src, { params: { download: true }, responseType: "blob" });
  saveBlob(data, filename);
}

export async function openAttachment(src) {
  const win = window.open("", "_blank");
  const { data } = await api.get(src, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  if (win) win.location.href = url;
  else window.location.assign(url);
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export function formatSize(bytes) {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1048576) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1048576).toFixed(1)} MB`;
}

export const MEDIA_LABELS = {
  image: "Imagem", video: "Vídeo", audio: "Áudio", document: "Documento",
  sticker: "Figurinha", location: "Localização", contact: "Contato",
};
